export const getPrincipalHomeScreen = (state, requestedScreen) => (
	dispatch
) => {
	let returnvalue = false;
	console.log("getPrincipalHomeScreen in=", state);
	if (state.auth.isAuthenticated) {
		if (
			state.auth.isAuthenticated &&
			!state.loadRoutes.isSaved &&
			requestedScreen === "SCREEN1"
		) {
			returnvalue = true;
		} else if (
			state.loadRoutes.isSaved &&
			!state.docSubmit.isSubmitted &&
			requestedScreen === "SCREEN2"
		) {
			returnvalue = true;
		} else if (state.docSubmit.isSubmitted && requestedScreen === "SCREEN3") {
			returnvalue = true;
		}

		/*auth.USER_LOADED;
				SCREEN1;
				---------loadRoutes.isSaved;
                SCREEN2;
                */
	}
	return returnvalue;
};
